module.exports = "images/header_logo.svg";